module.exports = __webpack_public_path__ + "img/theage.0e3c6579.png";